import type { RiskAssessmentDeniedReason } from "@/vue/entities/risk-assessment";

// サーバーのエラーコード（api-endpoints.md 5.5）を画面文言へ変換する（ui-design.md 7）。
// 403（ロール不足）は共通の axios interceptor が処理するため、ここでは扱わない。
const INVALID_INPUT_MESSAGE = "入力内容に不備があります。時間をおいて再度お試しください。";

export const GENERIC_ERROR_MESSAGE = "通信に失敗しました。時間をおいて再度お試しください。";

export const ERROR_MESSAGES: Record<string, string> = {
  not_assigned: "この相談の担当ではないため、リスクアセスメントを入力できません。",
  operation_period_expired: "操作可能期間を過ぎているため、リスクアセスメントを入力できません。",
  incomplete_answers: "すべての設問に回答してください。",
  unexpected_answers: INVALID_INPUT_MESSAGE,
  invalid_detail_key: INVALID_INPUT_MESSAGE,
  invalid_answer_type: INVALID_INPUT_MESSAGE,
  invalid_version_type: INVALID_INPUT_MESSAGE,
  invalid_consultable_type: INVALID_INPUT_MESSAGE,
  edit_period_expired: "修正可能期間（4時間）を過ぎているため、入力内容を修正できません。",
  stale_object: "他の端末で更新されました。最新の内容を読み込みます。",
  not_found: "対象の相談が見つかりません。"
};

export const extractErrorCode = (error: unknown): string | null => {
  const response = (error as { response?: { data?: { error?: string } } })?.response;

  return response?.data?.error ?? null;
};

export const resolveErrorMessage = (error: unknown): string => {
  const code = extractErrorCode(error);

  return (code && ERROR_MESSAGES[code]) || GENERIC_ERROR_MESSAGE;
};

// GET /new が startable: false を返したときのスナックバー文言。
export const deniedReasonMessage = (reason: RiskAssessmentDeniedReason | null): string =>
  (reason && ERROR_MESSAGES[reason]) || GENERIC_ERROR_MESSAGE;
